<template>
  <div>
    <a href="javascript:;" class="login_type_2" @click="loginWithFacebook">
      <img class="facebook" src="../assets/img/facebook.png" />
    </a>
  </div>
</template>

<script>
export default {
  name: "FacebookLogin",
  props: {
    fb_appid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isFbInitialized: false,
      isFbLoggedIn: false,
      showLoading: false,
    };
  },
  watch: {
    fb_appid: {
      immediate: true,
      handler(newVal) {
        if (newVal && !this.isFbInitialized) {
          this.initFacebookSDK();
        }
      },
    },
  },
  mounted() {
    if (this.fb_appid) {
      this.initFacebookSDK();
    }
  },
  // 页面销毁前执行清理操作
  beforeDestroy() {
    this.clearAllFBData();
  },
  methods: {
    initFacebookSDK() {
      const self = this;
      if (window.FB) {
        self.initializeFB();
      } else {
        window.fbAsyncInit = function() {
          self.initializeFB();
        };
        (function (d, s, id) {
          var js,
            fjs = d.getElementsByTagName(s)[0];
          if (d.getElementById(id)) return;
          js = d.createElement(s);
          js.id = id;
          js.src =
            "https://connect.facebook.net/zh_TW/sdk.js#xfbml=1&version=v18.0";
          fjs.parentNode.insertBefore(js, fjs);
        })(document, "script", "facebook-jssdk");
      }
    },

    initializeFB() {
      if (!this.fb_appid || !window.FB) return;

      FB.init({
        appId: this.fb_appid,
        cookie: true,
        xfbml: true,
        version: "v11.0",
      });

      this.isFbInitialized = true;
      this.checkFBLoginStatus();
    },

    checkFBLoginStatus() {
      if (!window.FB || !this.isFbInitialized) return;

      FB.getLoginStatus((response) => {
        this.isFbLoggedIn = response.status === "connected";
        if (this.isFbLoggedIn && response.authResponse?.accessToken) {
          localStorage.setItem(
            "fb_access_token",
            response.authResponse.accessToken
          );
        }
      });
    },

    loginWithFacebook() {
      if (!this.isFbInitialized || !this.fb_appid) {
        this.$message.warning("Facebook init");
        return;
      }

      FB.getLoginStatus((statusRes) => {
        if (statusRes.status === "connected") {
          this.Login(statusRes.authResponse.accessToken);
        } else {
          FB.login((loginRes) => {
            let res = { ...loginRes };
            console.log("loginRes:", res);

            if (res.authResponse?.accessToken) {
              this.isFbLoggedIn = true;
              localStorage.setItem(
                "fb_access_token",
                res.authResponse.accessToken
              );
              this.Login(res.authResponse.accessToken);
            } else {
              this.$message.error(res.status || "Facebook login error");
            }
          });
        }
      });
    },

    Login(access_token) {
      let game_id = this.$route.query.g;
      let params = { game_id, access_token };

      this.showLoading = true;

      this.$http
        .post("/login/fbLogin", params)
        .then((res) => {
          if (res.data.code === 200) {
            let token = res.data.data.token;
            localStorage.setItem("token", JSON.stringify(token));
            this.$router.push("/consume");
            this.$message.success(res.data.msg);
          } else {
            this.$message.error(`${res.data.code}: ${res.data.msg}`);
          }
        })
        .catch((err) => {
          console.error("login err：", err);
          this.$message.error(err);
        })
        .finally(() => {
          setTimeout(() => {
            this.showLoading = false;
          }, 2000);
        });
    },

    // 清除所有FB相关数据
    clearAllFBData() {
      // 1. 清除本地存储
      localStorage.removeItem("fb_access_token");

      // 2. 清除FB相关Cookie
      this.clearFBCookies();

      // 3. 调用FB.logout()清除会话（如果SDK已加载）
      if (window.FB) {
        FB.logout(() => {
          console.log("clean status");
        });
      }

      // 4. 重置状态
      this.isFbInitialized = false;
      this.isFbLoggedIn = false;
    },

    clearFBCookies() {
      const cookies = document.cookie.split(";");
      cookies.forEach((cookie) => {
        const cookieName = cookie.split("=")[0].trim();
        if (
          cookieName.includes("fb") ||
          cookieName.includes("facebook") ||
          cookieName === "xs"
        ) {
          document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${document.domain};`;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.facebook {
  width: 40px;
  height: 40px;
  cursor: pointer;
}
</style>
